import { Box, Checkbox, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import {
    formLabelStyling,
    stackStyling,
    formTextStyling,
} from 'components/forms/new/formStyles';

const AgreementCheckbox = ({
    state,
    onChange,
    darkMode,
    label,
    field,
    subText,
    walkthroughId,
}) => {
    return (
        <FormControl sx={{ margin: '0 !important' }}>
            <Stack direction="row" sx={{ ...stackStyling(), height: 'auto' }}>
                <Box width={190}>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                            minW: '190px',
                            overflowWrap: 'break-word',
                            whiteSpace: 'normal',
                            paddingY: '15px',
                        }}>
                        {label}
                    </FormLabel>
                </Box>
                <Field
                    as={Checkbox}
                    size="lg"
                    isChecked={state?.[field]}
                    onChange={onChange}
                    id={field}
                    name={field}
                    data-walkthroughid={walkthroughId}
                />

                <Box
                    display="flex"
                    alignItems="center"
                    sx={formTextStyling(darkMode)}>
                    <span>{subText}</span>
                </Box>
            </Stack>
        </FormControl>
    );
};

export default AgreementCheckbox;
